import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pro-privacy-view',
  templateUrl: './privacy-view.component.html',
  styleUrls: ['./privacy-view.component.scss'],
})
export class PrivacyViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
